import React, { useState } from "react";
import { Link2, Check } from "lucide-react";
import { copyDemoLink } from "@/compass/demoStore";

// Copies <current origin>/compass/demo. On clipboard failure the URL is shown
// in a selectable field so it can still be copied by hand.
export default function CopyDemoLinkButton({ className = "" }) {
  const [status, setStatus] = useState(null);
  const [fallbackUrl, setFallbackUrl] = useState("");

  const onCopy = async () => {
    const result = await copyDemoLink();
    if (result.ok) {
      setStatus("copied");
      setFallbackUrl("");
      setTimeout(() => setStatus(null), 2500);
    } else {
      setStatus("failed");
      setFallbackUrl(result.url);
    }
  };

  return (
    <div className={className}>
      <button
        type="button"
        onClick={onCopy}
        className="inline-flex items-center gap-2 rounded-lg border border-stone-300 bg-white px-3 py-2 text-sm font-medium text-stone-700 transition-colors hover:border-emerald-700 hover:text-emerald-800"
        data-testid="button-copy-demo-link"
      >
        {status === "copied" ? <Check className="h-4 w-4" /> : <Link2 className="h-4 w-4" />}
        {status === "copied" ? "Demo link copied" : "Copy demo link"}
      </button>
      {status === "failed" && (
        <div className="mt-2 max-w-sm text-xs text-stone-600" role="status" data-testid="status-copy-failed">
          Could not copy automatically. Select and copy this link:
          <input
            readOnly
            value={fallbackUrl}
            onFocus={(e) => e.target.select()}
            className="mt-1 w-full rounded border border-stone-300 bg-stone-50 px-2 py-1 font-mono text-xs"
            data-testid="input-demo-link-fallback"
          />
        </div>
      )}
    </div>
  );
}
